import React from "react";
import _filter from "lodash/filter";
import FormFader from "@/src/components/Form/Common/Fader/FormFader";
import Grid from "@mui/material/Grid";
import MultipleFileUpload from "@/src/components/Form/Common/FileUpload/MultipleFileUpload";
import FormSubmit from "@/src/components/Form/Common/FormSubmit/FormSubmit";
import { useForm } from "@/src/provider/Form/FormProvider";
import Typography from "@mui/material/Typography";
import FormLegend from "@/src/components/Form/Common/FormLegend/FormLegend";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import LegalbirdLoader from "@/src/components/ContentLoader/LegalbirdLoader";
import { fetchCollection, queryKeys } from "@/src/services/reactQuery/reactQueryService";
import { AbstractCase } from "@/src/types/Entities/AbstractCase";
import FormSubmitProps from "@/src/types/FormSubmitProps";
import wizardStyle from "@/src/components/Form/wizardStyle";
import { Box } from "@mui/material";
import ContentBox from "@/src/components/Box/ContentBox/ContentBox";

type DocumentsProps = {
  product: AbstractCase;
  submitProps: FormSubmitProps;
  headline?: string;
  mainDescription?: string;
  subDescription?: string;
};

export default function Documents({
  product,
  submitProps,
  headline = "Unterlagen",
  mainDescription = "Sie können hier gerne Unterlagen zu Ihrem Fall hochladen. Wenn Sie keine Unterlagen hochladen möchten, klicken Sie unten einfach auf “Weiter”.",
  subDescription = "Möchten Sie uns Unterlagen zukommen lassen, damit wir Ihr Anliegen besser einschätzen können? Dann laden Sie diese bitte hier hoch.",
}: DocumentsProps) {
  const queryClient = useQueryClient();
  const urlParams = {
    product: product.name,
    productId: product.id,
  };
  const { data: mediaObjectCollection, isLoading } = useQuery({
    queryKey: queryKeys.collection("/media_objects", urlParams),

    queryFn: () =>
      fetchCollection("/media_objects", urlParams)
  });
  const { handleSubmit } = useForm();

  const refreshMediaObjectCollection = () =>
    queryClient.invalidateQueries({
      queryKey: queryKeys.collection("/media_objects", urlParams),
    });

  if (isLoading) {
    return <LegalbirdLoader centered />;
  }

  return (
    <ContentBox>
      <FormFader>
        <Box component={"form"} sx={{ ...wizardStyle.applicationForm, ...wizardStyle.wizardForm, textAlign: "left" }} onSubmit={handleSubmit}>
          <Typography variant={"h5"} sx={(theme) => ({ color: theme.palette.text.primary, display: { xs: "block", sm: "none" }, textAlign: "left" })}>
            {headline}
          </Typography>
          <Grid
            container
            sx={{
              justifyContent: "flex-start",
              alignItems: "baseline",
            }}
          >
            <Grid sx={wizardStyle.gridTopSpaced} size={12}>
              <FormLegend>{mainDescription}</FormLegend>
            </Grid>
            <Grid sx={wizardStyle.gridTopSpaced} size={12}>
              <Typography variant={"h6"} sx={(theme) => ({ color: theme.palette.text.primary })}>{headline}</Typography>
              <p>{subDescription}</p>
              <MultipleFileUpload
                product={product}
                fieldname="applicationDocument"
                description={"Dokument"}
                mediaObjectCollection={_filter(mediaObjectCollection, ["fieldname", "applicationDocument"]) || []}
                fetchMediaObjects={refreshMediaObjectCollection}
              />
            </Grid>
          </Grid>
          <br />
          <br />
          <FormSubmit {...submitProps} />
        </Box>
      </FormFader>
    </ContentBox>
  );
}
